import React, { useState } from 'react'
import { useSearchMobileServiceNumbersQuery } from 'src/generated/graphql'
import { Input } from 'components/Input/Input'
import Tag from 'components/Tag'
import Button from 'components/Button'
import LoadingLinear from 'components/Loading/LoadingLinear'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import s from './AvailableStandardNumbers.scss'

export const AvailableStandardNumbers = props => {
  const { clearNumber, input } = props

  const [query, setQuery] = useState('')

  const { data, loading } = useSearchMobileServiceNumbersQuery({
    variables: {
      query,
    },
  })

  return (
    <>
      <Input
        label="Search standard number"
        type="number"
        input={{
          value: query,
          onChange: e => {
            setQuery(e.target.value)
            clearNumber()
          },
        }}
        meta={{}}
      />

      {loading ? (
        <div className={s.spinner}>
          <LoadingLinear />
        </div>
      ) : data?.searchMobileServiceNumbers.length ? (
        <div className={s.table}>
          {data?.searchMobileServiceNumbers.map((item, index) => (
            <div
              className={cn(sLay['layout-row'], sLay['layout-align-start-center'], s.row)}
              key={index}
            >
              <span className={sLay.flex}>{item.number}</span>

              <Tag idx={3} size="xs" style={{ marginRight: '1rem' }}>
                $35/mth
              </Tag>

              <Button
                onClick={() => input.onChange(item.number)}
                type="submit"
                color="tertiary"
                size="xs"
                ghost={input.value !== item.number}
              >
                Select
              </Button>
            </div>
          ))}
        </div>
      ) : (
        <div>No Results</div>
      )}
    </>
  )
}



// WEBPACK FOOTER //
// src/features/MobileServices/MobileServiceForm/AvailableStandardNumbers/AvailableStandardNumbers.tsx